import {Calendar as CalendarBase} from 'calendar-base';

let _instances = {};

/**
 * Utility to cache the calendar data instance so
 * that we can include it in multiple files and not
 * have to re-instantiate it.
 **/

function CalendarData(siblingMonths) {
    this.calendarData = new CalendarBase({siblingMonths});
}

CalendarData.prototype.setProperty = function(name, value) {
    this.calendarData[name] = value;
};

CalendarData.prototype.getMonth = function(year, month) {
    return this.calendarData.getCalendar(year, month);
};

function getCalendarDataInstance(siblingMonths) {
    const hash = siblingMonths ? 'siblingMonths' : 'noSiblingMonths';
    if (!_instances[hash]) {
        _instances[hash] = new CalendarData(siblingMonths);
    }
    return _instances[hash];
}

export {getCalendarDataInstance};
